const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogFuncao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogFuncao`, params);
    },
    $obterRelatorioLogCSVFuncao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogFuncaoCsv`, params);
    },
    $obterRelatorioLogPDFFuncao(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogFuncaoPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
